import api from './api';

export const categoryService = {
  /**
   * Listar todas as categorias
   */
  getAll: async (type = null) => {
    const params = type ? { type } : {};
    const response = await api.get('/categories', { params });
    return response;
  },

  /**
   * Criar nova categoria
   */
  create: async (data) => {
    const response = await api.post('/categories', data);
    return response;
  },

  /**
   * Atualizar categoria
   */
  update: async (categoryId, data) => {
    const response = await api.put(`/categories/${categoryId}`, data);
    return response;
  },

  /**
   * Excluir categoria
   */
  delete: async (categoryId) => {
    const response = await api.delete(`/categories/${categoryId}`);
    return response;
  },

  /**
   * Criar categorias padrão
   */
  seedDefaults: async () => {
    const response = await api.post('/categories/seed');
    return response;
  },
};

export default categoryService;
